import api from '..'

export class ReimbursementDeadlineService {
  static async findByBeneficiaryGroup(beneficiaryGroupId: string) {
    const response = await api.get('/reimbursement-deadlines', {
      params: { beneficiaryGroupId, sort: 'date' }
    })
    return response.data
  }
}
